import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=0b743dd3&"
import script from "./StudentInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./StudentInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=0b743dd3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports